// CRMOpenLead.js
import React, { useState, useEffect, useMemo, useRef } from "react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import "../assets/styles/CRMproject.css"
import "bootstrap/dist/css/bootstrap.min.css";
import propertyService from "../../services/propertyService";
import Toaster from "../../components/Toaster";
import projectImg from "../assets/img/productimg.svg";
import leadleft from "../assets/img/lead-left.svg";
import projectlogo from "../assets/img/projectlogo.svg";
import like from '../assets/img/projectlike.svg'
import dislike from '../assets/img/projectdislike.svg'
import paymentplan from '../assets/img/paymentplan.svg'
import projectpdf from '../assets/img/projectpdf.svg'
import projectgallery from '../assets/img/projectgallery.svg'
import projectexport from '../assets/img/projectexport.svg';
import projectshare from "../assets/img/projectshare.svg"


import hr from "../assets/img/24hr.svg";
import cctv from "../assets/img/cctv.svg";
import accesscontrol from "../assets/img/accesscontrol.svg";
import undercar from "../assets/img/undercar.svg";
import deliverybox from "../assets/img/deliverybox.svg";
import basement from "../assets/img/Basement.svg";



//Basic Infrasturuce
import watersupply from "../assets/img/watersupply.svg";
import parking from "../assets/img/parking.svg";
import power from "../assets/img/power.svg";
import sewage from '../assets/img/sewage.svg';
import elevator from "../assets/img/elevator.svg";



import swimming from "../assets/img/swimming.svg";
import gym from "../assets/img/gym.svg";
import kidsplay from "../assets/img/kidsplay.svg";
import club from "../assets/img/club.svg";
import partyroom from "../assets/img/partyroom.svg";
import theater from "../assets/img/theater.svg";
import garden from "../assets/img/garden.svg";
import partyarea from "../assets/img/partyarea.svg";
import yogacenter from "../assets/img/yogacenter.svg";
import shuttle from "../assets/img/shuttle.svg";
import cricket from "../assets/img/cricket.svg";
import football from "../assets/img/football.svg";
import basketball from "../assets/img/basketball.svg";
import meditaion from "../assets/img/meditiation.svg";
import jogging from "../assets/img/jogging.svg";
import skating from "../assets/img/skating.svg";
import cycling from "../assets/img/cycling.svg";


//Convenience Amenities
import retail from "../assets/img/retail.svg";
import restaurant from "../assets/img/restaurant.svg";
import medical from "../assets/img/medical.svg";
import diagnostic from "../assets/img/diagnostic.svg";
import grocery from "../assets/img/grocery.svg";
import atm from "../assets/img/atm.svg";
import laundry from "../assets/img/laundry.svg";
import internet from "../assets/img/internet.svg";


//Other Amenities

import petfriendly from "../assets/img/pet-friendly.svg";
import carwash from "../assets/img/car-wash.svg";
import solar from "../assets/img/solar.svg";
import led from "../assets/img/LED.svg";
import balcony from "../assets/img/Balcony.svg";
import mini from "../assets/img/mini-theater.svg";
import lounge from "../assets/img/lounge.svg";
import wifi from "../assets/img/wifi.svg";
import trash from "../assets/img/trash.svg";
import onsite from "../assets/img/on-site.svg";
import parkingarea from "../assets/img/visitor-parking-area.svg";
import saloon from "../assets/img/saloon.svg";


import { FaChevronDown, FaShareAlt, FaChevronUp } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import "swiper/css";
import "swiper/css/pagination";
// import propertyService from "../../services/propertyService";

const CONVENIENCE_FEATURES = [
  { icon: retail, label: "On-site retail spaces" },
  { icon: restaurant, label: "On-site restaurant" },
  { icon: medical, label: "Medical store" },
  { icon: diagnostic, label: "Diagnostic center" },
  { icon: grocery, label: "Grocery store" },
  { icon: atm, label: "ATM" },
  { icon: laundry, label: "Laundry facilities" },
  { icon: internet, label: "High speed internet" },
];
const OTHER_AMENITIES = [
  { icon: petfriendly, label: "Pet friendly amenities" },
  { icon: carwash, label: "Car wash" },
  { icon: solar, label: "Solar for 24hr hot water" },
  { icon: led, label: "LED lobby lights" },
  { icon: balcony, label: "Balcony garden" },
  { icon: mini, label: "Mini theater" },
  { icon: lounge, label: "Resident lounge" },
  { icon: wifi, label: "Common area WiFi" },
  { icon: trash, label: "Valet Trash service" },
  { icon: onsite, label: "On-site management" },
  { icon: parkingarea, label: "Visitor parking" },
  { icon: saloon, label: "Saloon & Spa" },
];

const SECURITY_ICONS = {
  '24/7 security personnel': hr,
  '24/7 Security personnel': hr,
  'CCTV': cctv,
  'Access control systems': accesscontrol,
  'Under car scanner': undercar,
  'Smart delivery boxes': deliverybox,
  'Basement security system': basement
};

// Helper function to check if an amenity exists in property data (exactly like mobile app)
const hasAmenity = (featureLabel, projectData) => {
  if (!projectData?.amenities) return false;
  return projectData.amenities.some(
    amenity => amenity.toLowerCase().includes(featureLabel.toLowerCase()) ||
      featureLabel.toLowerCase().includes(amenity.toLowerCase())
  );
};
const RECREATIONAL_FEATURES = [
  { icon: swimming, label: 'Swimming Pool' },
  { icon: gym, label: 'GYM' },
  { icon: kidsplay, label: 'Kids Play' },
  { icon: club, label: 'Club house' },
  { icon: partyroom, label: 'Party room' },
  { icon: theater, label: 'Theatre' },
  { icon: garden, label: 'Garden' },
  { icon: partyarea, label: 'Party area' },
  { icon: yogacenter, label: 'Yoga Center' },
  { icon: shuttle, label: 'Shuttle court' },
  { icon: cricket, label: 'Cricket practice net' },
  { icon: football, label: 'Football court' },
  { icon: basketball, label: 'Basketball Court' },
  { icon: meditaion, label: 'Meditation area' },
  { icon: jogging, label: 'Jogging track' },
  { icon: skating, label: 'Skating rink' },
  { icon: cycling, label: 'Cycling Path' },
];
export default function ProjectDetails() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const position = [17.4399, 78.4983]; // Example: Gachiboli coordinates

  console.group('ProjectDetails Navigation Debug');
  console.log('URL Parameter ID:', id);
  console.log('Location State:', location.state.project);
  const passedProject1 = location.state?.project;
  console.log('Passed Project1:', passedProject1);
  const passedBuilderName = location.state?.builderName;

  // If builder_company_name is 'Test Rep', use the builder name passed from navigation
  const getBuilderName = (projectData) => {
    if (!projectData) return 'Unknown Builder';
    if (projectData.builder_company_name === 'Test Rep' && passedBuilderName) {
      return passedBuilderName;
    }
    return projectData.builder_company_name || passedBuilderName || 'Unknown Builder';
  };

  console.log('Full Location Object:', location);
  console.groupEnd();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [project, setProject] = useState(null);

  // Thumbnail first, then gallery images without the duplicate (matches web app / mobile app)
  const projectImages = useMemo(() => {
    const toImageUrl = (img) => (img.startsWith('http') ? img : `https://sandbox.rebax.in${img}`);
    const thumb = project?.thumbnail || project?.project_logo;
    const images = [thumb, ...(Array.isArray(project?.images) ? project.images : [])]
      .filter(img => typeof img === 'string' && img)
      .map(toImageUrl);
    return Array.from(new Set(images));
  }, [project]);

  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    if (projectImages.length === 0) {
      setSelectedImage(null);
    } else if (!selectedImage || !projectImages.includes(selectedImage)) {
      setSelectedImage(projectImages[0]);
    }
  }, [projectImages, selectedImage]);

  // Step the main image through all gallery images, looping (used by autoplay and the chevrons)
  const stepGalleryImage = (delta) => {
    if (projectImages.length < 2) return;
    const idx = Math.max(0, projectImages.indexOf(selectedImage));
    setSelectedImage(projectImages[(idx + delta + projectImages.length) % projectImages.length]);
  };

  // Auto-advance the main image every 3s, looping back to the first.
  // Keyed on selectedImage so clicking a thumbnail or chevron restarts the countdown.
  useEffect(() => {
    if (projectImages.length < 2) return undefined;
    const timer = setTimeout(() => stepGalleryImage(1), 3000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectImages, selectedImage]);

  // Thumbnail strip shows 4 at a time; keep the selected one in view
  const thumbStripRef = useRef(null);
  useEffect(() => {
    const strip = thumbStripRef.current;
    const thumb = strip?.children[projectImages.indexOf(selectedImage)];
    if (!thumb) return;
    strip.scrollTo({ left: thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth' });
  }, [projectImages, selectedImage]);

  // Toast notification state
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success'
  });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const hideToast = () => {
    setToast(prev => ({ ...prev, show: false }));
  };

  useEffect(() => {
    const loadProject = async () => {
      console.group('🔍 ProjectDetails Loading');

      try {
        setLoading(true);
        setError(null);

        // 1) Use passed project first (if available)
        const passedProject = location.state?.project;

        if (passedProject) {
          console.log('✅ Using passed project data');
          const projectData = passedProject.originalData || passedProject;
          setProject(projectData);
        }

        // 2) Always fetch fresh data if id exists (recommended)
        if (!id) {
          console.error('No project ID found');
          setError('Invalid project ID');
          return;
        }

        console.log('📡 Fetching project details from API');
        const response = await propertyService.getProjectDetails(id);
        console.log('API Response:', response);

        if (response?.success && response?.data) {
          const apiProjectData = response.data.data || response.data;
          console.log('✅ Loaded project data from API:', apiProjectData);
          setProject(apiProjectData);
        } else {
          console.error('No project data found');
          setError('No project details available');
        }
      } catch (error) {
        console.error('Unexpected error:', error);
        setError(error?.message || 'An unexpected error occurred');
      } finally {
        setLoading(false);
        console.groupEnd();
      }
    };

    loadProject();
  }, [id, location.state]);


  const [activeTab, setActiveTab] = useState("All");
  const [activeTab1, setActiveTab1] = useState("All");
  const [selectedFloorType, setSelectedFloorType] = useState("All");
  const [selectedFloorSize, setSelectedFloorSize] = useState("All");
  const [openIndex, setOpenIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(true);
  const containerStyle = {
    width: "100%",
    height: "200px",
  };
  const center = {
    lat: project ? parseFloat(project.latitude) : 17.4399,
    lng: project ? parseFloat(project.longitude) : 78.4983
  };
  const toggleInvoice = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  const [active, setActive] = useState("All");
  const [active1, setActive1] = useState("Security");

  const buttons = [
    "Security",
    "Basic Infrastructure",
    "Recreational Amenities",
    "Convenience Amenities",
    "Other Amenities",
  ];
  const [activeSize, setActiveSize] = useState("1250 SFT");
  const sizes = ["1250 SFT", "1645 SFT", "1860 SFT", "2850 SFT", "3450 SFT"];
  // Use passed project data or fallback to default data
  const leadData = project ? {
    id: project.id,
    customer: {
      fullName: getBuilderName(project),
      address: project.address || "Location not specified",
    },
    property: {
      type: project.property_type || "Not Specified",
      bhk: `${project.bedrooms || 'Not Specified'}BHK`,
      community: project.community_type || "Not Specified",
      facing: project.facing_direction || "Not Specified",
      location: `${project.locality || 'Not Specified'}, ${project.city || 'Not Specified'}`,
      area: [
        parseFloat(project.area_sqft) || 0,
        parseFloat(project.area_sqft) || 0
      ],
      budget: [
        parseFloat(project.price) || 0,
        parseFloat(project.price_max) || 0
      ],
    },
    leadMgmt: {
      status: project.status || "Not Available",
      created: project.created_at ? new Date(project.created_at).toLocaleString() : "Not Available",
      modified: project.updated_at ? new Date(project.updated_at).toLocaleString() : "Not Available",
    },
    builders: [{
      name: getBuilderName(project),
      date: project.created_at ? new Date(project.created_at).toLocaleString() : "Not Available"
    }],
    details: {
      projectStatus: project.project_status || "Not Specified",
      completionDate: project.completion_date ? new Date(project.completion_date).toLocaleDateString() : "Not Available",
      reraId: project.rera_id || "Not Available",
      totalUnits: project.no_of_units || "Not Available",
      amenities: project.amenities || [],
      features: project.features || [],
    }
  } : {
    id: id || "20250513",
    customer: {
      fullName: "Alexander Mitchell",
      address: "13th Street, New York, NY 10011, USA",
    },
    property: {
      type: "Apartment",
      bhk: "2 BHK",
      community: "Green Estates Residences",
      facing: "North",
      location: "Downtown, Financial District",
      area: [800, 4500],
      budget: [20, 400],
    },
    leadMgmt: {
      status: "Yet to Contact",
      created: "May 13, 2025 at 10:35 AM",
      modified: "May 15, 2025 at 12:35 PM",
    },
    builders: [{ name: "ABC Builders", date: "May 6, 2025" }],
  };

  // Sliders state
  const [areaMin, setAreaMin] = useState(1200);
  const [areaMax, setAreaMax] = useState(2500);
  const [budgetMin, setBudgetMin] = useState(40);   // Lakhs
  const [budgetMax, setBudgetMax] = useState(120);  // Lakhs

  // Like/Dislike voting state
  const [likesCount, setLikesCount] = useState(0);
  const [dislikesCount, setDislikesCount] = useState(0);
  const [userVote, setUserVote] = useState(null);
  const [voteLoading, setVoteLoading] = useState(false);

  // Share state
  const [sharingFloorPlan, setSharingFloorPlan] = useState(null);

  // Download state for brochure generation
  const [downloadingItem, setDownloadingItem] = useState(null);

  // Load vote data when component mounts or project changes
  useEffect(() => {
    if (project?.id) {
      loadVoteData(project.id);
    }
  }, [project?.id]);

  // Load vote counts and user vote
  const loadVoteData = async (propId) => {
    try {
      const countsRes = await propertyService.getVoteCounts(propId);
      if (countsRes?.data) {
        setLikesCount(countsRes.data.likes_count || 0);
        setDislikesCount(countsRes.data.dislikes_count || 0);
      }
      try {
        const voteRes = await propertyService.getUserVote(propId);
        if (voteRes?.data) setUserVote(voteRes.data.user_vote || null);
      } catch (e) {
        console.log('Could not fetch user vote');
      }
    } catch (e) {
      console.log('Could not fetch vote counts');
    }
  };

  // Handle vote toggle
  const handleVote = async (voteType) => {
    if (!project?.id || voteLoading) return;
    const propId = project.id;

    setVoteLoading(true);
    try {
      const res = await propertyService.toggleVote(propId, voteType);
      if (res?.data) {
        setLikesCount(res.data.likes_count || 0);
        setDislikesCount(res.data.dislikes_count || 0);
        setUserVote(res.data.user_vote || null);
      }
    } catch (e) {
      console.log('Vote error:', e.message);
    } finally {
      setVoteLoading(false);
    }
  };

  // Generate professional PDF brochure (same design as mobile app)
  const handleGenerateBrochure = async () => {
    if (downloadingItem) return;

    try {
      setDownloadingItem('Project Brochure');
      const data = project || {};
      const projectName = data.property_title || 'Project';
      const builderName = getBuilderName(data);
      const location = data.address || data.locality || '';
      const city = data.city || '';
      const state = data.state || '';
      const currentDate = new Date().toLocaleDateString();

      // Create image URLs
      const heroImage = projectImages[0] || null;

      const fileName = `${projectName.replace(/[^a-zA-Z0-9]/g, '_')}_Brochure_${Date.now()}`;

      // Exact same HTML content as mobile app
      const htmlContent = `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>
        @page { margin: 0; size: A4; } * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif; color: #333; line-height: 1.6; }
        .cover-page { min-height: 100vh; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 40px; display: flex; flex-direction: column; page-break-after: always; }
        .cover-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
        .cover-logo { font-size: 32px; font-weight: 800; color: white; letter-spacing: 2px; }
        .cover-rera { background: rgba(255,255,255,0.2); padding: 8px 16px; border-radius: 20px; color: white; font-size: 14px; }
        .cover-hero { flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; }
        ${heroImage ? `.cover-image { width: 100%; max-height: 300px; object-fit: cover; border-radius: 20px; margin-bottom: 30px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }` : ''}
        .cover-title { font-size: 42px; font-weight: 800; color: white; margin-bottom: 10px; }
        .cover-subtitle { font-size: 22px; color: rgba(255,255,255,0.9); margin-bottom: 20px; }
        .cover-location { font-size: 18px; color: rgba(255,255,255,0.8); }
        .cover-price-box { background: white; padding: 25px 40px; border-radius: 15px; margin-top: 30px; text-align: center; }
        .cover-price-label { font-size: 14px; color: #666; text-transform: uppercase; letter-spacing: 1px; }
        .cover-price-value { font-size: 36px; font-weight: 800; color: #7C3AED; margin: 5px 0; }
        .cover-price-sqft { font-size: 16px; color: #888; }
        .content-page { padding: 40px; page-break-after: always; }
        .page-header { display: flex; justify-content: space-between; align-items: center; padding-bottom: 20px; border-bottom: 2px solid #7C3AED; margin-bottom: 30px; }
        .page-logo { font-size: 24px; font-weight: 800; color: #7C3AED; }
        .page-title { font-size: 18px; color: #666; }
        .section { margin-bottom: 35px; }
        .section-title { font-size: 24px; font-weight: 700; color: #1a1a2e; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 3px solid #7C3AED; display: inline-block; }
        .overview-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
        .overview-card { background: linear-gradient(135deg, #f8f9ff 0%, #fff 100%); padding: 20px; border-radius: 12px; border-left: 4px solid #7C3AED; }
        .overview-label { font-size: 13px; color: #888; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 5px; }
        .overview-value { font-size: 20px; font-weight: 700; color: #1a1a2e; }
        .description-text { font-size: 16px; line-height: 1.8; color: #444; text-align: justify; }
        .amenities-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
        .amenity-item { display: flex; align-items: center; gap: 10px; background: #f8f9ff; padding: 12px 15px; border-radius: 10px; }
        .amenity-check { width: 24px; height: 24px; background: #22c55e; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-size: 14px; font-weight: bold; }
        .amenity-name { font-size: 14px; color: #333; font-weight: 500; }
        .pricing-table { width: 100%; border-collapse: collapse; }
        .pricing-table th { background: #7C3AED; color: white; padding: 15px; text-align: left; font-size: 16px; }
        .pricing-table td { padding: 15px; border-bottom: 1px solid #e5e7eb; font-size: 15px; }
        .pricing-table tr:nth-child(even) { background: #f8f9ff; }
        .pricing-label { color: #666; } .pricing-value { font-weight: 600; color: #1a1a2e; text-align: right; }
        .page-footer { padding: 40px; text-align: center; font-size: 12px; color: #888; border-top: 1px solid #eee; }
        .footer-text { margin-bottom: 5px; }
        .footer-disclaimer { font-style: italic; margin-top: 15px; }
        .usp-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; margin-bottom: 30px; }
        .usp-card { background: linear-gradient(135deg, #f8f9ff 0%, #fff 100%); padding: 20px; border-radius: 12px; border-left: 4px solid #7C3AED; }
        .usp-title { font-size: 18px; font-weight: 700; color: #7C3AED; margin-bottom: 10px; }
        .usp-content { font-size: 14px; color: #666; line-height: 1.6; }
      </style></head><body>

        <div class="cover-page">
          <div class="cover-header">
            <div class="cover-logo">REBAX</div>
            ${data.rera_id ? `<div class="cover-rera">RERA: ${data.rera_id}</div>` : ''}
          </div>
          <div class="cover-hero">
            ${heroImage ? `<img src="${heroImage}" class="cover-image" />` : ''}
            <h1 class="cover-title">${projectName}</h1>
            <p class="cover-subtitle">by ${builderName}</p>
            <p class="cover-location">${location}${city ? `, ${city}` : ''}${state ? `, ${state}` : ''}</p>
            ${data.price ? `
              <div class="cover-price-box">
                <div class="cover-price-label">Starting Price</div>
                <div class="cover-price-value">₹${data.price}${data.price_max && data.price_max !== data.price ? ` - ₹${data.price_max}` : ''}</div>
                ${data.price_per_sqft ? `<div class="cover-price-sqft">₹${data.price_per_sqft}/sq.ft</div>` : ''}
              </div>
            ` : ''}
          </div>
        </div>

        <div class="content-page">
          <div class="page-header">
            <div class="page-logo">REBAX</div>
            <div class="page-title">Project Overview</div>
          </div>

          ${data.description ? `
            <div class="section">
              <h2 class="section-title">About ${projectName}</h2>
              <p class="description-text">${data.description}</p>
            </div>
          ` : ''}

          <div class="section">
            <h2 class="section-title">Project Specifications</h2>
            <div class="overview-grid">
              <div class="overview-card">
                <div class="overview-label">Property Type</div>
                <div class="overview-value">${data.property_type || 'Not Specified'}</div>
              </div>
              <div class="overview-card">
                <div class="overview-label">Project Status</div>
                <div class="overview-value">${data.project_status || 'Not Specified'}</div>
              </div>
              <div class="overview-card">
                <div class="overview-label">Total Units</div>
                <div class="overview-value">${data.no_of_units || 'Not Specified'}</div>
              </div>
              <div class="overview-card">
                <div class="overview-label">Total Floors</div>
                <div class="overview-value">${data.total_floors || 'Not Specified'}</div>
              </div>
              <div class="overview-card">
                <div class="overview-label">Total Towers</div>
                <div class="overview-value">${data.no_of_towers || 'Not Specified'}</div>
              </div>
              <div class="overview-card">
                <div class="overview-label">Completion Date</div>
                <div class="overview-value">${data.completion_date ? new Date(data.completion_date).toLocaleDateString() : 'Not Specified'}</div>
              </div>
            </div>
          </div>

          ${data.usp && data.usp.length > 0 ? `
            <div class="section">
              <h2 class="section-title">USP Highlights</h2>
              <div class="usp-grid">
                ${data.usp.map(usp => `
                  <div class="usp-card">
                    <div class="usp-title">${usp.title}</div>
                    <div class="usp-content">${usp.content}</div>
                  </div>
                `).join('')}
              </div>
            </div>
          ` : ''}

          ${data.amenities && data.amenities.length > 0 ? `
            <div class="section">
              <h2 class="section-title">Amenities</h2>
              <div class="amenities-grid">
                ${data.amenities.map(amenity => `
                  <div class="amenity-item">
                    <div class="amenity-check">✓</div>
                    <div class="amenity-name">${amenity}</div>
                  </div>
                `).join('')}
              </div>
            </div>
          ` : ''}

          <div class="section">
            <h2 class="section-title">Pricing Details</h2>
            <table class="pricing-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                ${data.price ? `<tr><td class="pricing-label">Budget Range</td><td class="pricing-value">₹${data.price}${data.price_max && data.price_max !== data.price ? ` - ₹${data.price_max}` : ''}</td></tr>` : ''}
                ${data.price_per_sqft ? `<tr><td class="pricing-label">Price Per Sq.Ft</td><td class="pricing-value">₹${data.price_per_sqft}</td></tr>` : ''}
                ${data.car_parking_cost ? `<tr><td class="pricing-label">Car Parking Cost</td><td class="pricing-value">₹${data.car_parking_cost}</td></tr>` : ''}
                ${data.amenities_cost ? `<tr><td class="pricing-label">Amenities Cost</td><td class="pricing-value">₹${data.amenities_cost}</td></tr>` : ''}
                ${data.maintenance_cost ? `<tr><td class="pricing-label">Maintenance Cost</td><td class="pricing-value">₹${data.maintenance_cost} per sq.ft ${data.maintenance_type ? `for ${data.maintenance_type}` : ''}</td></tr>` : ''}
              </tbody>
            </table>
          </div>

          ${data.agent_commission ? `
            <div class="section">
              <h2 class="section-title">Agent Commission</h2>
              <div class="overview-card" style="max-width: 500px;">
                <div class="overview-label">Commission Structure</div>
                <div class="overview-value">${data.agent_commission}</div>
              </div>
            </div>
          ` : ''}

          <div class="page-footer">
            <div class="footer-text">Generated on ${currentDate}</div>
            <div class="footer-text">Powered by REBAX</div>
            <div class="footer-disclaimer">This brochure is for informational purposes only. Please contact for the most up-to-date information.</div>
          </div>
        </div>

      </body></html>`;

      // Create HTML element from string
      const element = document.createElement('div');
      element.innerHTML = htmlContent;
      element.style.width = '800px'; // Fixed width for consistent PDF output
      element.style.position = 'absolute';
      element.style.left = '-9999px'; // Hide element off-screen
      document.body.appendChild(element);

      try {
        // Generate canvas from HTML
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          letterRendering: true,
          allowTaint: false,
          backgroundColor: '#ffffff'
        });

        // Create PDF
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        });

        const imgData = canvas.toDataURL('image/jpeg', 0.85);
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;

        let position = 0;

        // Add image to PDF, splitting across multiple pages if needed
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        // Save PDF
        pdf.save(`${fileName}.pdf`);

        showToast('Project brochure downloaded successfully!', 'success');
      } catch (pdfError) {
        console.error('PDF generation error:', pdfError);
        showToast('Failed to generate PDF. Please try again.', 'error');
      } finally {
        // Clean up
        document.body.removeChild(element);
      }

    } catch (error) {
      console.error('Error generating brochure:', error);
      showToast('Failed to generate brochure. Please try again.', 'error');
    } finally {
      setDownloadingItem(null);
    }
  };

  // Enhanced share floor plan function (similar to mobile app)
  const handleShareFloorPlan = async (floorPlan, index) => {
    setSharingFloorPlan(index);
    try {
      const projectTitle = project?.property_title || 'Property';
      const planTitle = floorPlan.type || 'Floor Plan';
      const planSize = floorPlan.size ? `${floorPlan.size} ${floorPlan.sizeUnit || 'SFT'}` : 'N/A';
      const bedrooms = floorPlan.bedrooms || 2;
      const bathrooms = floorPlan.bathrooms || 2;

      const message = `🏠 ${projectTitle} - Floor Plan\n\n🛏 Type: ${planTitle}\n📐 Size: ${planSize}\nBedrooms: ${bedrooms}\nBathrooms: ${bathrooms}\n\nFor more details, please contact.`;

      const imgUrl = floorPlan.image_url;

      if (imgUrl && navigator.share) {
        // Try to share with image URL
        const fullUrl = imgUrl.startsWith('http') ? imgUrl : `https://sandbox.rebax.in${imgUrl}`;

        try {
          // For web, we can't download and share files like mobile apps,
          // but we can share the URL and text content
          await navigator.share({
            title: `Floor Plan - ${planTitle}`,
            text: message,
            url: fullUrl
          });
        } catch (shareErr) {
          // If sharing with URL fails, try just text
          if (shareErr.name !== 'AbortError') {
            await navigator.share({
              title: `Floor Plan - ${planTitle}`,
              text: message
            });
          }
        }
      } else if (navigator.share) {
        // Share just the text if no image or no share support for URLs
        await navigator.share({
          title: `Floor Plan - ${planTitle}`,
          text: message
        });
      } else {
        // Fallback: copy to clipboard
        navigator.clipboard.writeText(message).then(() => {
          showToast('Floor plan details copied to clipboard!', 'success');
        });
      }

    } catch (error) {
      if (error.name !== 'AbortError') {
        console.log('Error sharing floor plan:', error);
        // Fallback: copy to clipboard
        const projectTitle = project?.property_title || 'Property';
        const planTitle = floorPlan.type || 'Floor Plan';
        const planSize = floorPlan.size ? `${floorPlan.size} ${floorPlan.sizeUnit || 'SFT'}` : 'N/A';
        const message = `🏠 ${projectTitle} - Floor Plan\n\n🛏 Type: ${planTitle}\n📐 Size: ${planSize}`;

        navigator.clipboard.writeText(message).then(() => {
          showToast('Floor plan details copied to clipboard!', 'success');
        });
      }
    } finally {
      setSharingFloorPlan(null);
    }
  };

  return (
    <>
      <div className="d-flex">
        <LeftNav />
        <div className=" flex-grow-1">
          <TopNav />

          <div className="dashboard mt-2 p-2">
            <div className="crm-openlead-container p-4">

              {/* Lead ID + actions */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="d-flex align-items-center">
                  <img
                    src={leadleft}
                    className="me-2"
                    alt="back"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(-1)}
                  />
                  {projectImages[0] && (
                    <img
                      src={projectImages[0]}
                      className="me-2"
                      alt="back"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(-1)}
                      width="36" height="36"
                    />
                  )}

                  <div>
                    <div className="project-detail-header mb-2" style={{ margin: 0 }}>
                      {project?.property_title || 'Project Details'}
                    </div>
                    <div className="project-detail-name mt-2">
                      by{' '}
                      <span
                        style={{ cursor: 'pointer', color: '#6366F1', textDecoration: 'underline' }}
                        onClick={() => project?.builder_id && navigate('/AdminAgencyViewBuilder', { state: { userId: project.builder_id } })}
                      >
                        {getBuilderName(project)}
                      </span>
                    </div>
                    {/* Show the 6-char project_code, not the UUID (hidden until the API returns it) - matching mobile app */}
                    {project?.project_code ? (
                      <div className="project-detail-name mt-2">
                        Project Id: {project.project_code}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="d-flex align-items-center gap-3">

                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="vote-btn btn p-0 border-0 bg-transparent d-flex align-items-center gap-1"
                      onClick={() => handleVote('like')}
                      disabled={voteLoading}
                      style={{
                        cursor: voteLoading ? 'wait' : 'pointer',
                        transition: 'transform 0.2s ease',
                        transform: userVote === 'like' ? 'scale(1.05)' : 'scale(1)'
                      }}
                      onMouseEnter={(e) => !voteLoading && (e.currentTarget.style.transform = 'scale(1.1)')}
                      onMouseLeave={(e) => !voteLoading && (e.currentTarget.style.transform = userVote === 'like' ? 'scale(1.05)' : 'scale(1)')}
                    >
                      <img
                        src={like}
                        alt="like"
                        width="24"
                        height="24"
                        style={{
                          filter: userVote === 'like' ? 'brightness(0) saturate(100%) invert(53%) sepia(83%) saturate(456%) hue-rotate(71deg) brightness(96%) contrast(92%)' : 'none',
                          transition: 'filter 0.2s ease'
                        }}
                      />
                      <span
                        style={{
                          color: userVote === 'like' ? '#4CAF50' : '#666',
                          fontWeight: userVote === 'like' ? '700' : 'normal',
                          fontSize: userVote === 'like' ? '15px' : '14px',
                          transition: 'all 0.2s ease'
                        }}
                      >
                        {likesCount}
                      </span>
                    </button>
                    <button
                      className="vote-btn btn p-0 border-0 bg-transparent d-flex align-items-center gap-1"
                      onClick={() => handleVote('dislike')}
                      disabled={voteLoading}
                      style={{
                        cursor: voteLoading ? 'wait' : 'pointer',
                        transition: 'transform 0.2s ease',
                        transform: userVote === 'dislike' ? 'scale(1.05)' : 'scale(1)'
                      }}
                      onMouseEnter={(e) => !voteLoading && (e.currentTarget.style.transform = 'scale(1.1)')}
                      onMouseLeave={(e) => !voteLoading && (e.currentTarget.style.transform = userVote === 'dislike' ? 'scale(1.05)' : 'scale(1)')}
                    >
                      <img
                        src={dislike}
                        alt="dislike"
                        width="24"
                        height="24"
                        style={{
                          filter: userVote === 'dislike' ? 'brightness(0) saturate(100%) invert(37%) sepia(93%) saturate(1687%) hue-rotate(339deg) brightness(94%) contrast(92%)' : 'none',
                          transition: 'filter 0.2s ease'
                        }}
                      />
                      <span
                        style={{
                          color: userVote === 'dislike' ? '#F44336' : '#666',
                          fontWeight: userVote === 'dislike' ? '700' : 'normal',
                          fontSize: userVote === 'dislike' ? '15px' : '14px',
                          transition: 'all 0.2s ease'
                        }}
                      >
                        {dislikesCount}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              {(selectedImage || projectImages[0]) && (
                <img
                  src={selectedImage || projectImages[0]}
                  className="me-2"
                  alt="back"
                  width="100%"
                  height="350px"
                />
              )}
              {projectImages.length > 0 && (
                <div className="mt-4" style={{ position: "relative" }}>
                  {/* overflow hidden = no scrollbar; chevrons / autoplay move the strip via scrollTo */}
                  <div ref={thumbStripRef} className="d-flex gap-2" style={{ position: "relative", overflow: "hidden", padding: "2px" }}>
                    {projectImages.map((img, idx) => (
                      <img
                        key={`${img}-${idx}`}
                        src={img}
                        alt={`image${idx + 1}`}
                        style={{
                          flex: "0 0 calc(25% - 6px)",
                          width: "24%",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "10px",
                          cursor: "pointer",
                          outline: (selectedImage || projectImages[0]) === img ? "2px solid #6F70FA" : "none"
                        }}
                        onClick={() => setSelectedImage(img)}
                      />
                    ))}
                  </div>
                  {/* Only needed when there are more thumbnails than fit (4 across) */}
                  {projectImages.length > 4 &&
                    [
                      { key: "prev", side: "left", delta: -1, Icon: IoChevronBack, label: "Previous image" },
                      { key: "next", side: "right", delta: 1, Icon: IoChevronForward, label: "Next image" },
                    ].map(({ key, side, delta, Icon, label }) => (
                      <button
                        key={key}
                        type="button"
                        aria-label={label}
                        onClick={() => stepGalleryImage(delta)}
                        style={{
                          position: "absolute",
                          top: "50%",
                          [side]: "-12px",
                          transform: "translateY(-50%)",
                          width: "34px",
                          height: "34px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid #E5E7EB",
                          borderRadius: "50%",
                          background: "#fff",
                          color: "#111827",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                          cursor: "pointer",
                        }}
                      >
                        <Icon size={18} />
                      </button>
                    ))}
                </div>
              )}
              <div >
                <div className="crm-card1  p-2 mt-4">
                  {/* Top row */}

                  <div className="d-flex justify-content-between align-items-center mb-2">

                    {/* Left side: stacked text */}
                    <div className="d-flex flex-column justify-content-center" style={{
                      // decrease this value to make corners less rounded
                    }}>
                      <span className="agent-commission">
                        Agent Commission
                      </span>
                      <span className="agent-commission-value mt-3" >
                        {project?.agent_commission || '2.75%'}% after {project?.payout_after || '20'}% Payment
                      </span>
                    </div>

                    {/* Right side: View Terms with icon */}
                    <div
                      className="d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (project?.terms_url) {
                          const url = project.terms_url.startsWith('http')
                            ? project.terms_url
                            : `https://sandbox.rebax.in${project.terms_url}`;
                          window.open(url, '_blank');
                        } else {
                          showToast('Terms & Conditions document not available', 'error');
                        }
                      }}
                    >
                      <span style={{ fontSize: "12px", fontWeight: "600", color: "#6F70FA", marginRight: "5px" }}>
                        View Terms
                      </span>
                      <IoDocumentTextOutline
                        size={18}
                        color="#7C3AED"
                        style={{ marginLeft: 6 }}
                      />
                    </div>
                  </div>
                </div>
                <div className="crm-car mb-4 mt-4">
                  <div style={{}}>
                    {/* Header */}
                    <h2 className="project-overview-label" style={{ margin: 0 }}>
                      Project Overview
                    </h2>

                    {/* All text in one tag */}
                    <p className="project-overview-text mt-3" style={{ lineHeight: "1.5" }}>
                      {project?.description || 'No description available'}
                    </p>
                  </div>

                </div>
                {/* USP Highlights - Fixed data binding */}
                {(() => {
                  // Check if USP data exists in project
                  const uspData = project?.usp;
                  let displayUsp = null;

                  if (uspData && Array.isArray(uspData) && uspData.length > 0) {
                    displayUsp = uspData;
                  } else {
                    // If USP is empty, show message instead of hiding section
                    console.log('USP data:', uspData);
                    console.log('Project data:', project);
                  }

                  if (displayUsp && displayUsp.length > 0) {
                    return (
                      <>
                        <div className="project-overview-label mb-3 mt-3">USP Highlights</div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr", // 2 cards per row
                            gap: "20px",
                          }}
                        >
                          {displayUsp.map((usp, index) => {
                            // Handle both object and string formats like mobile app
                            const uspItem = typeof usp === 'string'
                              ? { title: `Highlight ${index + 1}`, content: usp }
                              : {
                                title: usp.title || usp.name || `Highlight ${index + 1}`,
                                content: usp.content || usp.description || usp.value || usp.text || ''
                              };

                            const colorSchemes = [
                              { bg: "#3BBB001A", color: "#3BBB00" },
                              { bg: "#4995FF1A", color: "#4995FF" },
                              { bg: "#09FFC61A", color: "#008364" },
                              { bg: "#9747FF1A", color: "#9747FF" },
                              { bg: "#FF097C1A", color: "#FF097C" },
                              { bg: "#FB64001A", color: "#FB6400" }
                            ];

                            const scheme = colorSchemes[index % colorSchemes.length];

                            return (
                              <div
                                key={index}
                                style={{
                                  borderRadius: "8px",
                                  padding: "15px",
                                  background: scheme.bg,
                                }}
                              >
                                <p style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: scheme.color, fontFamily: "Manrope" }}>
                                  {uspItem.title}
                                </p>
                                <p style={{ margin: 0, fontSize: "15px", fontWeight: "600", color: "#808080", fontFamily: "Manrope" }}>
                                  {uspItem.content}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <div className="project-overview-label mb-3 mt-3">USP Highlights</div>
                        <div style={{ padding: "20px", textAlign: "center", color: "#888", border: "1px dashed #ddd", borderRadius: "8px" }}>
                          No USP highlights available for this project
                        </div>
                      </>
                    );
                  }
                })()}
                <div className="d-flex justify-content-between align-items-center mb-3 mt-2"
                  onClick={() => setOpen(!open)}
                  style={{ cursor: "pointer" }}>
                  <div className="d-flex align-items-center">
                    <span className="project-overview-label mt-4" >Property Specification</span>
                  </div>
                </div>
                {open && (
                  <div className="mt-4 px-3"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr", // 3 cards per row
                      gap: "20px",
                    }}
                  >
                    {[
                      ['Property Type', project?.property_type || 'Residential'],
                      ['Community', project?.community_type || 'Gated'],
                      ['Location', (() => {
                        const loc = project?.city;
                        if (loc && !/^(flat|plot|door|no[\.\s]|survey|#|\d+[-\/])/i.test(loc) && !/^\d+$/.test(loc)) return loc;
                        const addr = project?.address || project?.location || '';
                        if (!addr) return project?.city || 'N/A';
                        const parts = addr.split(',').map(p => p.trim());
                        const skip = /^(flat|plot|door|no[\.\s]|survey|#|\d+[-\/])/i;
                        const cityIdx = parts.findIndex(p => /hyderabad|mumbai|bangalore|bengaluru|chennai|delhi|kolkata|pune|ahmedabad|jaipur|lucknow|noida|gurgaon|gurugram|vizag|visakhapatnam/i.test(p));
                        const search = cityIdx > 0 ? parts.slice(0, cityIdx) : parts;
                        for (let i = search.length - 1; i >= 0; i--) {
                          if (!skip.test(search[i]) && search[i].length > 2 && !/^\d+$/.test(search[i])) return search[i];
                        }
                        return project?.city || 'N/A';
                      })()],
                      ['Project Status', project?.project_status || 'Under Construction'],
                      ['Completion Date', project?.completion_date ? new Date(project.completion_date).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : 'To be announced'],
                      ['Project Area', project?.area_sqft ? `${project.area_sqft} sqft` : 'N/A'],
                      ['No.of Towers', project?.no_of_towers || 'N/A'],
                      ['Total Floors', project?.total_floors ? `G+${project.total_floors}` : 'N/A'],
                      ['Total Units', project?.no_of_units || 'N/A'],
                      ['Available Facings', project?.facing || 'Multiple facings available'],
                      ['RERA ID', project?.rera_id || 'N/A'],
                      ['Agent Commission', project?.agent_commission ? `${project.agent_commission}% after ${project.payout_after || 'N/A'}% Payment` : 'N/A']
                    ].map(([label, value], idx) => (
                      <div key={idx} className="project-specification-card">
                        <p className="project-specification-label">{value}</p>
                        <p className="project-specification-type">{label}</p>
                      </div>
                    ))}
                  </div>
                )}
                <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
                  <div className="d-flex align-items-center">

                    <span className="project-overview-label mt-4">Property Pricing</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <FaChevronDown color="#000" style={{ cursor: "pointer" }} />

                  </div>
                </div>
                <div className="mt-4 px-3"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr", // 3 cards per row
                    gap: "20px",
                  }}
                >
                  {(() => {
                    // Format budget in Lakhs/Cr (abbreviated)
                    const formatBudget = (val) => {
                      const num = parseFloat(val);
                      if (isNaN(num)) return 'N/A';
                      if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(1)} Cr`;
                      if (num >= 100000) return `₹ ${(num / 100000).toFixed(0)} Lakhs`;
                      return `₹ ${num.toLocaleString('en-IN')}`;
                    };
                    // Format other prices as full numbers
                    const formatFull = (val) => {
                      const num = parseFloat(val);
                      if (isNaN(num)) return null;
                      return num.toLocaleString('en-IN');
                    };

                    const pricingData = [
                      ['Budget Range', project?.price_max ? `${formatBudget(project.price)} - ${formatBudget(project.price_max)}` : formatBudget(project?.price)],
                      ['Price Per SFT', project?.price_per_sqft ? `₹ ${formatFull(project.price_per_sqft)}` : 'N/A'],
                      ['Car Parking Cost', project?.car_parking_cost ? `₹ ${formatFull(project.car_parking_cost)}` : 'N/A'],
                      ['Extra car parking cost', project?.extra_car_parking_cost ? `₹ ${formatFull(project.extra_car_parking_cost)}` : 'N/A'],
                      ['Corner Premium', project?.corner_premium ? `₹ ${formatFull(project.corner_premium)} per ${project.corner_premium_unit || 'SFT'}` : 'N/A'],
                      ['Amenities cost', project?.amenities_cost ? `₹ ${formatFull(project.amenities_cost)}` : 'N/A'],
                      ['Floor rise charges', project?.floor_rise ? `₹ ${formatFull(project.floor_rise)} per ${project.floor_rise_unit || 'SFT'}${project.floor_rise_from_floor ? ` from ${project.floor_rise_from_floor}th Floor` : ''}` : 'N/A'],
                      ['Corpus Fund', project?.corpus_fund ? `₹ ${formatFull(project.corpus_fund)}` : 'N/A'],
                      ['Maintenance per year', project?.maintenance_cost && project?.maintenance_type ? `₹ ${formatFull(project.maintenance_cost)} ${project.maintenance_type}` : 'N/A']
                    ];

                    return pricingData.map(([label, value], idx) => (
                      <div key={idx} className="project-specification-card">
                        <p className="project-specification-label">{value}</p>
                        <p className="project-specification-type">{label}</p>
                      </div>
                    ));
                  })()}
                  {/* Facing Charges - Per Direction */}
                  {(() => {
                    const facingCharges = project?.facing_charges;
                    if (!facingCharges) return null;
                    try {
                      const charges = typeof facingCharges === 'string' ? JSON.parse(facingCharges) : facingCharges;
                      return Object.entries(charges).map(([direction, data]) => (
                        <div key={direction} className="project-specification-card">
                          <p className="project-specification-label">₹ {data.amount || '0'} per {data.unit || 'SFT'}</p>
                          <p className="project-specification-type">{direction} Facing</p>
                        </div>
                      ));
                    } catch (e) {
                      return null;
                    }
                  })()}
                </div>
                {project?.floor_plans && project.floor_plans.length > 0 && (
                  <div className="crm-card mt-4 p-4">
                    <h2 className="project-overview-label mb-3">Floor Plans</h2>
                    <div className="flex gap-3 mb-3 flex-wrap">
                      <div className="crm-tabs d-flex align-items-center">
                        <button
                          className={`crm-tab ${selectedFloorType === "All" ? "active1" : ""}`}
                          onClick={() => setSelectedFloorType("All")}
                        >
                          All
                        </button>
                        {[...new Set(project.floor_plans.map(plan => plan.type))].map((type) => (
                          <button
                            key={type}
                            className={`crm-tab ${selectedFloorType === type ? "active1" : ""}`}
                            onClick={() => setSelectedFloorType(type)}
                          >
                            {type}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="flex gap-3 mb-3 flex-wrap">
                      <div className="crm-tabs1 d-flex align-items-center">
                        <button
                          style={{ margin: "0 6px", padding: "20px", whiteSpace: "nowrap" }}
                          className={`crm-tab4 ${selectedFloorSize === "All" ? "active" : ""}`}
                          onClick={() => setSelectedFloorSize("All")}
                        >
                          All
                        </button>
                        {[...new Set(project.floor_plans.map(plan => `${plan.size} ${plan.sizeUnit || 'SFT'}`))].
                          map((size) => (
                            <button
                              key={size}
                              style={{ margin: "0 6px", padding: "20px", whiteSpace: "nowrap" }}
                              className={`crm-tab4 ${selectedFloorSize === size ? "active" : ""}`}
                              onClick={() => setSelectedFloorSize(size)}
                            >
                              {size}
                            </button>
                          ))
                        }
                      </div>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr", // 3 cards per row
                        gap: "20px",
                      }}
                    >
                      {project.floor_plans
                        .filter(plan =>
                          (selectedFloorType === "All" || plan.type === selectedFloorType) &&
                          (selectedFloorSize === "All" || `${plan.size} ${plan.sizeUnit || 'SFT'}` === selectedFloorSize)
                        )
                        .map((plan, index) => (
                          <div key={index} className="crm-card mt-4 p-2">
                            <div
                              style={{
                                borderRadius: "8px",
                                background: "#fff",
                                overflow: "hidden",
                              }}
                            >
                              {plan.image_url && (
                                <img
                                  src={plan.image_url.startsWith('http') ? plan.image_url : `https://sandbox.rebax.in${plan.image_url}`}
                                  alt="floor plan"
                                  style={{ width: "100%", height: "150px", objectFit: "cover" }}
                                />
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "8px 10px",
                                }}
                              >
                                <span className="floor-plan-label">{plan.type}</span>
                                {sharingFloorPlan === index ? (
                                  <div className="spinner-border spinner-border-sm" role="status" style={{ width: "16px", height: "16px" }}>
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  <img
                                    src={projectshare}
                                    width={20}
                                    height={20}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleShareFloorPlan(plan, index)}
                                  />
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "6px 10px",
                                }}
                              >
                                <span className="floor-plan-values">Size</span>
                                <span className="floor-plan-values">{plan.size} {plan.sizeUnit || 'SFT'}</span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "6px 10px",
                                }}
                              >
                                <span className="floor-plan-values">Type</span>
                                <span className="floor-plan-values">
                                  {plan.bedrooms ? `${plan.bedrooms} Bed, ${plan.bathrooms || 1} Bath` :
                                    plan.type ? plan.type :
                                      '2 Bed, 2 Bath'}
                                </span>
                              </div>
                              {/* Additional plan details */}
                              {plan.facing && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "6px 10px",
                                  }}
                                >
                                  <span className="floor-plan-values">Facing</span>
                                  <span className="floor-plan-values">{plan.facing}</span>
                                </div>
                              )}
                              {plan.floors && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "6px 10px",
                                  }}
                                >
                                  <span className="floor-plan-values">Floors</span>
                                  <span className="floor-plan-values">{plan.floors}</span>
                                </div>
                              )}
                              {plan.title && (
                                <div
                                  style={{
                                    padding: "6px 10px",
                                  }}
                                >
                                  <span className="floor-plan-values" style={{ fontSize: "12px", color: "#888" }}>
                                    {plan.title}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                )}
                <div style={{ display: "flex", gap: "10px" }} className="mt-4">
                  {buttons.map((btn) => (
                    <button
                      key={btn}
                      onClick={() => setActive1(btn)}
                      style={{
                        padding: "6px 16px",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                        backgroundColor: active1 === btn ? "#000" : "#fff",
                        color: active1 === btn ? "#fff" : "#000",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      {btn}
                    </button>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",

                    gap: "30px",
                    padding: "16px",
                    border: "1px solid #E2E4E9",
                    borderRadius: "12px",
                    backgroundColor: "#fff",
                    overflowX: "auto",
                    flexWrap: "wrap",      // 👈 this makes items go to next line
                    justifyContent: "flex-start" // 👈 optional: center the items nicely
                  }}
                  className="mt-4"
                >
                  {active1 === "Security" && (
                    <>
                      {Object.entries(SECURITY_ICONS)
                        .filter(([featureLabel]) => hasAmenity(featureLabel, project))
                        .map(([featureLabel, icon], index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center"
                            }}
                          >
                            <img
                              src={icon}
                              alt="Security"
                              style={{
                                borderRadius: "30px",
                                width: "40px",
                                height: "40px"
                              }}
                            />
                            <span className="mt-2 project-detail-labels">
                              {featureLabel}
                            </span>
                          </div>
                        ))}
                      {Object.entries(SECURITY_ICONS)
                        .filter(([featureLabel]) => hasAmenity(featureLabel, project)).length === 0 && (
                          <div style={{ width: '100%', textAlign: 'center', color: '#888', padding: '20px' }}>
                            No security amenities available
                          </div>
                        )}
                    </>
                  )}
                  {active1 === "Basic Infrastructure" && (
                    <>
                      {[
                        { icon: watersupply, label: 'Water supply' },
                        { icon: power, label: 'Power backup' },
                        { icon: sewage, label: 'Sewage management' },
                        { icon: elevator, label: 'Elevator' },
                        { icon: parking, label: 'Ample parking' }
                      ]
                        .filter(item => hasAmenity(item.label, project))
                        .map((item, idx) => (
                          <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img
                              src={item.icon}
                              alt="Basic Infrastructure"
                              style={{ borderRadius: "30px", width: "40px", height: "40px" }}
                            />
                            <span className="mt-2 project-detail-labels">{item.label}</span>
                          </div>
                        ))}

                      {[
                        { icon: watersupply, label: 'Water supply' },
                        { icon: power, label: 'Power backup' },
                        { icon: sewage, label: 'Sewage management' },
                        { icon: elevator, label: 'Elevator' },
                        { icon: parking, label: 'Ample parking' }
                      ].filter(item => hasAmenity(item.label, project)).length === 0 && (
                          <div style={{ width: '100%', textAlign: 'center', color: '#888', padding: '20px' }}>
                            No basic infrastructure amenities available
                          </div>
                        )}
                    </>
                  )}
                  {active1 === "Recreational Amenities" && (
                    <>
                      {RECREATIONAL_FEATURES
                        .filter(item => hasAmenity(item.label, project))
                        .map((item, idx) => (
                          <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img
                              src={item.icon}
                              alt="Recreational Amenities"
                              style={{ borderRadius: "30px", width: "40px", height: "40px" }}
                            />
                            <span className="mt-2 project-detail-labels">{item.label}</span>
                          </div>
                        ))}

                      {RECREATIONAL_FEATURES.filter(item => hasAmenity(item.label, project)).length === 0 && (
                        <div style={{ width: '100%', textAlign: 'center', color: '#888', padding: '20px' }}>
                          No recreational amenities available
                        </div>
                      )}
                    </>
                  )}

                  {active1 === "Convenience Amenities" && (
                    <>
                      {CONVENIENCE_FEATURES
                        .filter(item => hasAmenity(item.label, project))
                        .map((item, idx) => (
                          <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img
                              src={item.icon}
                              alt="Convenience Amenities"
                              style={{ borderRadius: "30px", width: "40px", height: "40px" }}
                            />
                            <span className="mt-2 project-detail-labels">{item.label}</span>
                          </div>
                        ))}

                      {CONVENIENCE_FEATURES.filter(item => hasAmenity(item.label, project)).length === 0 && (
                        <div style={{ width: '100%', textAlign: 'center', color: '#888', padding: '20px' }}>
                          No convenience amenities available
                        </div>
                      )}
                    </>
                  )}
                  {active1 === "Other Amenities" && (
                    <>
                      {OTHER_AMENITIES
                        .filter(item => hasAmenity(item.label, project))
                        .map((item, idx) => (
                          <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img
                              src={item.icon}
                              alt="Other Amenities"
                              style={{ borderRadius: "30px", width: "40px", height: "40px" }}
                            />
                            <span className="mt-2 project-detail-labels">{item.label}</span>
                          </div>
                        ))}

                      {OTHER_AMENITIES.filter(item => hasAmenity(item.label, project)).length === 0 && (
                        <div style={{ width: '100%', textAlign: 'center', color: '#888', padding: '20px' }}>
                          No other amenities available
                        </div>
                      )}
                    </>
                  )}
                </div>
                {/* --- Location --- */}
                <div className="crm-openlead-location-section1 mt-4">
                  <div className="crm-openlead-location-header">
                    <span className="project-overview-label">Location</span>

                    <img
                      src={projectshare}
                      width={20}
                      height={20}
                      style={{ cursor: "pointer" }}
                      className="crm-openlead-shareicon"
                      onClick={() => {
                        const lat = project?.latitude;
                        const lng = project?.longitude;
                        const title = project?.property_title || 'Property';
                        const fullAddress = project?.address ||
                          [project?.locality, project?.city, project?.state]
                            .filter(Boolean)
                            .join(', ') ||
                          'Address not available';
                        const googleMapsUrl = lat && lng ? `https://maps.google.com/?q=${lat},${lng}` : '';
                        const resolvedBuilderName = getBuilderName(project);
                        const message = `🏠 ${title}\n📍 ${fullAddress}${resolvedBuilderName ? `\n🏢 by ${resolvedBuilderName}` : ''}${googleMapsUrl ? `\n\n📌 View on Google Maps: ${googleMapsUrl}` : ''}`;

                        if (navigator.share) {
                          navigator.share({
                            title: `Share - ${title}`,
                            text: message,
                            url: googleMapsUrl || window.location.href
                          }).catch(err => console.log('Error sharing:', err));
                        } else {
                          navigator.clipboard.writeText(message).then(() => {
                            showToast('Location details copied to clipboard!', 'success');
                          });
                        }
                      }}
                    />
                  </div>

                  {/* Google Map */}
                  <LoadScript googleMapsApiKey="AIzaSyBeeIWUhRhc2ZW9oKxUugzu8y9JQgFVcvA" libraries={["places"]}>
                    <GoogleMap
                      mapContainerClassName="crm-openlead-map-container"
                      center={center}
                      zoom={15}
                    >
                      <Marker position={center} onClick={() => setSelected(center)} />
                      {selected && (
                        <InfoWindow position={center} onCloseClick={() => setSelected(null)}>
                          <div style={{ maxWidth: '200px' }}>
                            <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                              {project?.property_title || 'Property Location'}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              {project?.locality || project?.city || 'Location'}
                            </div>
                          </div>
                        </InfoWindow>
                      )}
                    </GoogleMap>
                  </LoadScript>

                  <div className="crm-openlead-location-footer">
                    <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '8px' }}>
                      <div style={{ fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                        {project?.property_title || 'Property Location'}
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.4' }}>
                        {project?.address ||
                          [project?.locality, project?.city, project?.state]
                            .filter(Boolean)
                            .join(', ') ||
                          'Address not available'}
                      </div>
                      {project?.locality && project?.address && project?.locality !== project?.address && (
                        <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                          Locality: {project.locality}
                        </div>
                      )}
                    </div>
                  </div>
                </div>


              </div>
              <div className="mt-4 project-overview-label mb-3">Downloads</div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  width: "100%",
                  padding: "10px",
                  background: "#fff",
                }}
              >
                {/* Project Brochure - Always available like mobile app */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderRadius: "8px",
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    // If brochure_url exists, open it directly (same as Payment Plans/Terms)
                    if (project?.brochure_url) {
                      const url = project.brochure_url.startsWith('http')
                        ? project.brochure_url
                        : `https://sandbox.rebax.in${project.brochure_url}`;
                      window.open(url, '_blank');
                    } else {
                      // Generate professional brochure with same design as mobile app
                      handleGenerateBrochure();
                    }
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{
                      backgroundColor: '#FFE5E5',
                      padding: "12px",
                      borderRadius: "10px"
                    }}>
                      <img
                        src={projectpdf}
                        alt="Project Brochure"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ fontSize: "16px", fontWeight: "600" }}>Project Brochure</span>
                      <span style={{ fontSize: "14px", color: "#555" }}>PDF</span>
                    </div>
                  </div>
                  <img
                    src={projectexport}
                    alt="download"
                    style={{ width: "50px", height: "50px", borderRadius: "8px" }}
                  />
                </div>

                {/* Gallery Images - Show only if images exist */}
                {/* {project?.images && project.images.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderRadius: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      // Create a ZIP-like experience by opening images in new tabs
                      project.images.forEach((img, index) => {
                        setTimeout(() => {
                          window.open(img, `_blank_${index}`);
                        }, index * 500); // Stagger the opening
                      });
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div>
                        <img
                          src={projectgallery}
                          alt="Gallery Images"
                          style={{ width: "40px", height: "40px", borderRadius: "8px" }}
                        />
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "16px", fontWeight: "600" }}>Gallery Images</span>
                        <span style={{ fontSize: "14px", color: "#555" }}>{project.images.length} Images</span>
                      </div>
                    </div>
                    <img
                      src={projectexport}
                      alt="download"
                      style={{ width: "50px", height: "50px", borderRadius: "8px" }}
                    />
                  </div>
                )} */}

                {/* Payment Plans - Show only if payment_plan_url exists */}
                {project?.payment_plan_url && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderRadius: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      const url = project.payment_plan_url.startsWith('http')
                        ? project.payment_plan_url
                        : `https://sandbox.rebax.in${project.payment_plan_url}`;

                      window.open(url, '_blank');

                      // Show warning after opening
                      setTimeout(() => {
                        showToast('Important Notice: This PDF may contain builder contact data. While sharing it with your client, please be cautious.', 'error');
                      }, 500);
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div>
                        <img
                          src={paymentplan}
                          alt="Payment Plans"
                          style={{ width: "40px", height: "40px", borderRadius: "8px" }}
                        />
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "16px", fontWeight: "600" }}>Payment Plans</span>
                        <span style={{ fontSize: "14px", color: "#555" }}>PDF</span>
                      </div>
                    </div>
                    <img
                      src={projectexport}
                      alt="download"
                      style={{ width: "50px", height: "50px", borderRadius: "8px" }}
                    />
                  </div>
                )}

                {/* Terms & Conditions - Show only if terms_url exists */}
                {project?.terms_url && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderRadius: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      const url = project.terms_url.startsWith('http')
                        ? project.terms_url
                        : `https://sandbox.rebax.in${project.terms_url}`;
                      window.open(url, '_blank');
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div>
                        <img
                          src={projectpdf}
                          alt="Terms & Conditions"
                          style={{ width: "40px", height: "40px", borderRadius: "8px" }}
                        />
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "16px", fontWeight: "600" }}>Terms & Conditions</span>
                        <span style={{ fontSize: "14px", color: "#555" }}>PDF</span>
                      </div>
                    </div>
                    <img
                      src={projectexport}
                      alt="download"
                      style={{ width: "50px", height: "50px", borderRadius: "8px" }}
                    />
                  </div>
                )}

                {/* Brochure URL - Show only if brochure_url exists */}
                {project?.brochure_url && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderRadius: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      const url = project.brochure_url.startsWith('http')
                        ? project.brochure_url
                        : `https://sandbox.rebax.in${project.brochure_url}`;
                      window.open(url, '_blank');
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div>
                        <img
                          src={projectpdf}
                          alt="Property Brochure"
                          style={{ width: "40px", height: "40px", borderRadius: "8px" }}
                        />
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "16px", fontWeight: "600" }}>Property Brochure</span>
                        <span style={{ fontSize: "14px", color: "#555" }}>PDF</span>
                      </div>
                    </div>
                    <img
                      src={projectexport}
                      alt="download"
                      style={{ width: "50px", height: "50px", borderRadius: "8px" }}
                    />
                  </div>
                )}

                {/* Show message if no downloads available - Project Brochure is always available */}
                {!project?.payment_plan_url &&
                  !project?.terms_url &&
                  (!project?.images || project.images.length === 0) && (
                    <div style={{ padding: "20px", color: "#888", textAlign: "center" }}>
                      Additional downloads not available
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div>
    </div> */}


      {/* Toast Notifications */}
      <Toaster
        show={toast.show}
        message={toast.message}
        type={toast.type}
        duration={5}
        onClose={hideToast}
      />
    </>
  );
}